import React, { Component, } from 'react';
import { string, element } from 'prop-types';
import Table from '../../../../legacy-tv-ui/Table';
import Td from '../../../../legacy-tv-ui/Td';
import Tr from '../../../../legacy-tv-ui/Tr';
import Th from '../../../../legacy-tv-ui/Th';

const IndicatorTd = ({ children, bgc }) => (
  <Td
    style={{
      textAlign: 'center',
      backgroundColor: bgc,
    }}
  >
    {children}
  </Td>
);

IndicatorTd.propTypes = {
  children: element.isRequired,
  bgc: string.isRequired
};

export class IndicatorTable extends Component {
  static propTypes = {}
  static defaultProps = {}
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Table style={{ minWidth: 720, }}>
        <thead>
          <Tr>
            <Th>技術指標</Th>
            <Th colSpan="2">總經指標</Th>
            <Th>計量指標</Th>
          </Tr>
        </thead>
        <tbody>
          <Tr>
            <IndicatorTd bgc="#f5f5f5">
              Chaikin Oscillator
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              兌美元匯率
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">Total market cap/ GDP</IndicatorTd>
            <IndicatorTd>
              TV自製指標
            </IndicatorTd>
          </Tr>
          <Tr>
            <IndicatorTd bgc="#f5f5f5">
              Accumulate Distribution
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              AUD/JPY
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              各國利率
            </IndicatorTd>
            <IndicatorTd />
          </Tr>
          <Tr>
            <IndicatorTd bgc="#f5f5f5">
              CAPE
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              長期政府公債
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              消費者信心指數
            </IndicatorTd>
            <IndicatorTd />
          </Tr>
          <Tr>
            <IndicatorTd bgc="#f5f5f5">
              MACD
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              公司債殖利率
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              失業率
            </IndicatorTd>
            <IndicatorTd />
          </Tr>
          <Tr>
            <IndicatorTd bgc="#f5f5f5">
              RSI
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              黃金
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              貨幣供給
            </IndicatorTd>
            <IndicatorTd />
          </Tr>
          <Tr>
            <IndicatorTd bgc="#f5f5f5">
              Stochastic Oscillator
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              石油
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              CLI景氣領先指標
            </IndicatorTd>
            <IndicatorTd />
          </Tr>
          <Tr>
            <IndicatorTd bgc="#f5f5f5">
              ROC
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              VIX
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              Force Index
            </IndicatorTd>
            <IndicatorTd />
          </Tr>
          <Tr>
            <IndicatorTd bgc="#f5f5f5">
              DMI Oscillator
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              30/60/120天波動率
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9">
              Money Flow Index
            </IndicatorTd>
            <IndicatorTd />
          </Tr>
          <Tr>
            <IndicatorTd bgc="#f5f5f5" />
            <IndicatorTd bgc="#f9f9f9">
              GDP變動率
            </IndicatorTd>
            <IndicatorTd bgc="#f9f9f9" />
            <IndicatorTd />
          </Tr>

        </tbody>
      </Table>
    );
  }
}

export default IndicatorTable;



// WEBPACK FOOTER //
// ./src/scenes/Prediction/components/IndicatorTable/index.js